import { Component, input, OnInit } from '@angular/core';
import { BaseViewComponent, FormContainerKind } from '@sb/library/base';

@Component({
    selector: 'lib-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss'],
})
export class LabelComponent extends BaseViewComponent implements OnInit {
    // I really want to use Scope but we are in a hot mess and I don't want to break anything by trying to add it in now. 
    // So instead, I'm just going to add the required inputs until we can properly refactor this component to use Scope.
    // Scope = this.SetScope({
    //     Requires: [FormFieldBaseScope, FormFieldContainerScope]
    // })
    readonly FormContainerKind = FormContainerKind;

    formFieldID = input<string>('');
    isRequired = input<boolean>(false);
    isDisabled = input<boolean>(false);
    kind = input<FormContainerKind>(FormContainerKind.Default);
    isReadonly = input<boolean>(false);
    
    
}
